import {z} from "zod";
import {BasePlatformObject} from "../../../schemas";

export const ActivityLogSchema = BasePlatformObject.extend(
    {
        action: z.string()
                 .min(1, 'action is required'),
        created: z.string()
                  .datetime()
                  .min(1, 'created is required'),
        id: z.string()
             .min(1, 'id is required'),
        recordId: z.string()
                   .min(1, 'recordId is required'),
        recordType: z.string()
                     .optional(),
        usageType: z.string()
                    .min(1, 'usageType is required'),
        username: z.string()
                   .min(1, 'username is required'),
        user: z.object({
            username: z.string(),
            email: z.string().optional(),
            name: z.string().optional(),
            status: z.string().optional(),
            created: z.string().optional()
        }).optional(),
        value: z.number()
                .min(1, 'value is required'),
    })

export const GetActivityLogParser = z.object(
    {
        data: z.object({getActivityLog: ActivityLogSchema})
    })